module.exports = __webpack_public_path__ + "media/Images/icon-user-o-b2326bb2c39f620effd9cf826341f3ff.svg";